import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import c from 'classnames';
import IconWrap from '../IconWrap';
import s from '../Animated.scss';
const GiftAnimated = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        id: "assets",
        xmlSpace: "preserve"
    }, props), {
        width: "0",
        height: "0",
        viewBox: "0 0 32 32"
    }), /*#__PURE__*/ React.createElement("path", {
        className: c(s['anim'], s['anim-hue-rotate'], s['anim-duration-2s']),
        d: "M15.2,19.8L9.2,19.8L9.2,23.8C9.2,24.352 9.648,24.8 10.2,24.8L15.2,24.8L15.2,19.8ZM23.2,23.8L23.2,19.8L17.2,19.8L17.2,24.8L22.2,24.8C22.752,24.8 23.2,24.352 23.2,23.8ZM18.916,7.21C18.805,7.137 18.711,7.082 18.641,7.051C18.136,6.826 17.545,7.053 17.32,7.558L16.217,10.035L15.114,7.558L15.06,7.454C14.805,7.023 14.262,6.842 13.794,7.051L13.69,7.104C13.609,7.152 13.491,7.241 13.351,7.355L13.127,7.546L12.88,7.765L12.536,8.085L12.198,8.412L11.893,8.721L11.691,8.939C11.601,9.039 11.53,9.124 11.486,9.187C11.169,9.639 11.279,10.263 11.732,10.58L13.474,11.799L8.2,11.8C7.648,11.8 7.2,12.248 7.2,12.8L7.2,14.3C7.2,14.852 7.648,15.3 8.2,15.3L9.2,15.299L9.2,17.8L15.2,17.8L15.2,11.8L17.2,11.8L17.2,17.8L23.2,17.8L23.2,15.299L24.2,15.3C24.752,15.3 25.2,14.852 25.2,14.3L25.2,12.8C25.2,12.248 24.752,11.8 24.2,11.8L19.232,11.799L20.975,10.58C21.427,10.263 21.537,9.639 21.22,9.187C21.176,9.124 21.105,9.042 21.012,8.946L20.802,8.739L20.68,8.625L20.355,8.334L20.001,8.033L19.64,7.741L19.294,7.476C19.248,7.441 19.203,7.409 19.159,7.377L18.916,7.21Z",
        style: {
            fill: 'rgb(217,217,217)'
        }
    })));
GiftAnimated.displayName = 'GiftAnimated';
export default GiftAnimated;
